import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/esnext.string.replace-all.js";
// Inspired by strings.dasherize in @angular-devkit/core

export var toKebabCase = function toKebabCase(val) {
  return val
  // When a number or lowercase letter is followed by an uppercase letter, insert a dash
  .replaceAll(/([a-z\d])([A-Z])/g, '$1-$2')
  // Replace spaces and underscores with dashes
  .replaceAll(/[\s\_]/g, '-').toLowerCase();
};